import { IEventDownloadQRCode } from './gtag.type';

type GtagFn = (event: string, payload: object) => void;

const EMPTY_GTAG: GtagFn = (event, payload, prefix = 'LOCAL_') => {
  console.log(`gtag('${prefix}${event}', ${JSON.stringify(payload, null, 4)})`);
};

// catch potential error
// DOMException: Blocked a frame with origin "https://widget-trueqrcode-dev.osdb.io" from accessing a cross-origin frame.
const getGtag = (): { gtag: GtagFn; dataLayer: any[] } => {
  // use gtag from window on PROD if available
  const dataLayer: any[] = (window as any).dataLayer || [];
  try {
    if (!dataLayer) {
      console.log('dataLayer not available');
      return { gtag: EMPTY_GTAG, dataLayer };
    }
    const gtag: GtagFn = (event, payload) => {
      // structure of dataLayer item depends on Google Tag Manager version
      dataLayer.push({ event, ...payload });
    };
    return { gtag, dataLayer };
  } catch {
    console.log('dataLayer not available');
    return { gtag: EMPTY_GTAG, dataLayer };
  }
};

const { gtag: _gtag, dataLayer } = getGtag();

const buildEventDispatcher =
  <T extends object>(event: string) =>
  (payload: T) =>
    _gtag(event, payload);

/**
 * Google Tag Analytics manager to dispatch typed events
 */
export const gtag = {
  mapper: {
    // sample
    // normalizeEntity: (entity: EntityInDto) => ({
    //     pax: entity.prop,
    //     pets: entity.otherProp.map(e => e.details).join(', ') || undefined,
    // }),
  },

  // general
  // let GA know which user is here
  initialSessionStart: ({ user_id }: { user_id: string }) => dataLayer.push({ user_id }),
  changeLanguage: buildEventDispatcher<{ language: string }>('change_language'),
  changeCurrency: buildEventDispatcher<{ currency: string }>('change_currency'),

  // qr widget specific
  expandFramesAccordion: buildEventDispatcher<{ value: string }>('expand_frames_accordion'),
  downloadQRCode: buildEventDispatcher<IEventDownloadQRCode>('download_qr_code'),
  attemptSignUp:
    buildEventDispatcher<{ authentication_method: 'google' | 'email'; user_email?: string }>('attempt_sign_up'),

  // auth on user app
  signUp:
    buildEventDispatcher<{ authentication_method: 'google' | 'email'; user_email: string; user_id: string }>(
      'registration'
    ),
  purchase: buildEventDispatcher<{
    user_email: string;
    user_id: string;
    ecommerce: {
      // TODO provide after backend changes for that.
      // invoice_id: '12345';
      // price
      value: number;
      // e.g. EUR
      currency: string;
      items: [
        {
          // Plan_ID
          item_id: string;
          // e.g. Basic_Monthly_EUR
          item_name: string;
          price: number;
          quantity: 1;
        }
      ];
    };
  }>('purchase'),
};
